/**
 * Session Mode Selection Page
 *
 * Redirects to /conversation/new or /dictation/new based on user preference.
 */

import { Header, Sidebar } from '@/components/layout';
import { Loader2 } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useLocation } from 'wouter';

export default function SessionNew() {
  const [, navigate] = useLocation();
  const [_isLoading, _setIsLoading] = useState(true);

  useEffect(() => {
    const fetchSettingsAndRedirect = async () => {
      try {
        const response = await fetch('/api/settings', {
          credentials: 'include',
          headers: { Accept: 'application/json' },
        });

        let defaultMode = 'conversation';
        if (response.ok) {
          const data = await response.json();
          const savedMode = data.features?.default_session_mode;
          if (savedMode === 'dictation' || savedMode === 'conversation') {
            defaultMode = savedMode;
          }
        }

        // Redirect to the appropriate page
        if (defaultMode === 'dictation') {
          navigate('/dictation/new', { replace: true });
        } else {
          navigate('/conversation/new', { replace: true });
        }
      } catch (error) {
        console.error('Error fetching settings:', error);
        // Default to conversation on error
        navigate('/conversation/new', { replace: true });
      }
    };

    fetchSettingsAndRedirect();
  }, [navigate]);

  // Show loading while redirecting
  return (
    <div className="flex h-screen bg-background">
      <Sidebar />
      <div className="flex flex-1 flex-col overflow-hidden">
        <Header title="Ný lota" />
        <main className="flex flex-1 items-center justify-center">
          <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
        </main>
      </div>
    </div>
  );
}
